import React, {createContext, useReducer} from 'react'
import AppReducer from './AppReducer.js' 
// initial state
const initialState = {
    transactions:  []
}

// create context 
export const GlobalContext = createContext(initialState);

// provider component
export const GlobalProvider = ({children}) => {
    const [state,dispatch] = useReducer(AppReducer,initialState);

    //actions
    const deleteTransaction = id =>{
        dispatch({
            type: "DELETE_TRANS",
            payload: id,
        })
    }

    const addTransaction = transaction=>{
        dispatch({
            type: "ADD_TRANS",
            payload: transaction,
        })
    }

    return (<GlobalContext.Provider value={{transactions: state.transactions,deleteTransaction,addTransaction}}>
        {children}
    </GlobalContext.Provider>)
}